import { Box, TableCell, TableRow } from '@mui/material'
import { IconButton, Typography } from '@carto/meridian-ds/components'
import UserAvatar from 'features/users/ui/UserAvatar'
import UserEmail from 'features/account/ui/AccountUsers/AccountUsersTable/UserEmail'
import { MoreVertOutlined } from '@mui/icons-material'
import { Users } from 'features/account/types'
import { useMemo } from 'react'
import useAccountQueries from 'features/account/api/accountQueries'
import { useQuery } from 'react-query'

function OwnerRow({ owner, hideActions }: { owner: Users; hideActions?: boolean }) {
  // TODO: This is a temporal solution to avoid error while importing useUsers.
  // Due it's in accountHooks it tries to import FF hooks and finally some JSON files
  const { queries } = useAccountQueries()
  const { data: users } = useQuery({ ...queries.getUsers })
  const isRepeated = useMemo(
    () => users?.some((u) => u.email === owner.email && u.user_id !== owner.user_id),
    [users, owner]
  )

  return (
    <TableRow>
      <TableCell width={32} padding="checkbox">
        <UserAvatar user={owner} />
      </TableCell>
      <TableCell width={310}>
        <Box width="inherit" overflow="hidden">
          <UserEmail user={owner} showAuthMethod={isRepeated} />
        </Box>
      </TableCell>

      <TableCell width={100}>
        <Typography variant="body2" color="textSecondary">
          Owner
        </Typography>
      </TableCell>

      {!hideActions && (
        <TableCell width={48} align="right" padding="checkbox">
          <IconButton disabled icon={<MoreVertOutlined />} />
        </TableCell>
      )}
    </TableRow>
  )
}

export default OwnerRow
